export function initBlogCategorySlider() {
    document.addEventListener('DOMContentLoaded', function () {
        const categories = document.querySelectorAll('.blogPage__categoryWrapper--main');
        const categoriesTax = document.querySelectorAll('.blogPage__categoryWrapper--tax');

        if (categories) {
            categories.forEach(category => {
                const splide = new window.splide(category, {
                    gap: '12px',
                    pagination: false,
                    arrows: true,
                    perPage: 6,
                    perMove: 1,
                    arrowPath: 'M16.9091 8.13814C17.1434 7.90382 17.5233 7.90382 17.7576 8.13814L25.7576 16.1381C25.8701 16.2507 25.9333 16.4033 25.9333 16.5624C25.9333 16.7215 25.8701 16.8741 25.7576 16.9867L17.7576 24.9867C17.5233 25.221 17.1434 25.221 16.9091 24.9867C16.6747 24.7524 16.6747 24.3725 16.9091 24.1381L23.8848 17.1624H6.66665C6.33528 17.1624 6.06665 16.8938 6.06665 16.5624C6.06665 16.231 6.33528 15.9624 6.66665 15.9624H23.8848L16.9091 8.98667C16.6747 8.75235 16.6747 8.37245 16.9091 8.13814Z',
                    breakpoints: {
                          992: {
                            perPage: 1,
                            autoWidth: true,
                            arrows: false,
                        },
                    }
                });
                splide.mount();
            })
        }

        if (categoriesTax) {
            categoriesTax.forEach(category => {
                const splide = new window.splide(category, {
                    gap: '12px',
                    pagination: false,
                    arrows: false,
                    perPage: 1,
                    perMove: 1,
                    mediaQuery: 'min',
                    autoWidth: true,
                    breakpoints: {
                        992: {
                            destroy: true,
                        }
                    }
                });
                splide.mount();
            })
        }
    })
}